import { render, staticRenderFns } from "./productInOrder.vue?vue&type=template&id=136119e8&"
import script from "./productInOrder.vue?vue&type=script&lang=js&"
export * from "./productInOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports